import React, { useEffect, useState } from "react";
// import FooterIndex from "./Footer/FooterIndex";
import HeaderIndex from "./Header/HeaderIndex";
import NewFooterIndex from "./Footer/FooterIndex";
import { useDispatch, useSelector } from "react-redux";
import { profileStart } from "../../store/actions/UserAction";
import PageLoader from "../helper/PageLoader";
import SomethingWentWrong from "../Common/SomethingWentWrong";
import { useLocation, useNavigate } from "react-router-dom";
import { staticEmailListStart } from "../../store/actions/BankAccountAction";

const MainLayout = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("token") || sessionStorage.getItem("token")
      ? true
      : false
  );
  const profile = useSelector((state) => state.user.profile)
  const logout = useSelector((state) => state.user.logout);
  const [skipRender, setSkipRender] = useState(true);

  useEffect(() => {
    if (isLoggedIn && !Object.keys(profile.data).length > 0) {
      dispatch(profileStart())
      // dispatch(staticEmailListStart());
    }
  }, [])

  useEffect(() => {
    if (!skipRender && !logout.loading && Object.keys(logout.data).length > 0) {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("lang", "en");
      navigate("/login");
    }
    setSkipRender(false);
  }, [logout]);

  useEffect(()=> {
    if(!profile.loading && Object.keys(profile.data).length > 0){
      if(pathname == "/buy" && !profile.data.user_configuration.buy){
        navigate(-1)
      } else if(pathname == "/sell" && !profile.data.user_configuration.sell){
        navigate(-1)
      } else if(pathname == "/exchange" && !profile.data.user_configuration.exchange){
        navigate(-1)
      } else if(pathname == "/trading" && !profile.data.user_configuration.trade){
        navigate(-1)
      } 
    }
  }, [pathname, profile])

  return (
    <>
      {/* {profile.buttonDisable ? <PageLoader /> : (Object.keys(profile.data).length > 0 || !isLoggedIn) ? */}
      
        <>
          {/* <HeaderIndex /> */}
          <div className="main-wrapper">
            {props.children}
          </div>
          {/* <FooterIndex/> */}
          <div className="auth-footer">
            <NewFooterIndex />
          </div>
        </>
        {/* : <SomethingWentWrong />
      } */}
    </>
  );
};

export default MainLayout;
